/**
 * Move the main content block into the hero on webform nodes and the
 * focused-mode CiviCRM donation forms. Content is rendered normally (so
 * forms keep their normal POST / rebuild flow) then relocated into the
 * hero's content column, and its emptied .section.bg-white wrapper is
 * hidden. Non-focused civi pages (e.g. events) are left alone.
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.webformHero = {
    attach: function () {
      var body = document.body;
      var onHeroPage =
        body.classList.contains("page-node-type-webform") ||
        (body.classList.contains("page-civicrm") &&
          body.classList.contains("focused-mode"));
      if (!onHeroPage) {
        return;
      }

      // .text-column only exists on the image/cover hero variants; on
      // others (e.g. standard) fall back to the hero's content column.
      var target =
        document.querySelector(".section--hero .text-column") ||
        document.querySelector(".section--hero .row .col");
      var content = document.getElementById("block-endometriosis-uk-content");

      if (
        !target ||
        !content ||
        target.contains(content) ||
        !once("webform-hero", content).length
      ) {
        return;
      }

      var wrapper = content.closest(".section.bg-white");

      var messages = document.getElementById("block-endometriosis-uk-messages");
      if (messages && !target.contains(messages)) {
        target.appendChild(messages);
      }
      target.appendChild(content);

      if (wrapper) {
        wrapper.classList.add("is-relocated-to-hero");
      }
    },
  };
})(jQuery, Drupal, once);
